import './multibloc.scss';

/**
 * version    1.0
 * class      <type> (Multibloc)
 */
export class Multibloc {}
